import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px auto',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const enhance = compose();

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={onClickAction}
      className={classes.button}
    >
      認証コードを送る
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
